import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_RichText = _resolveComponent("RichText")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.requestState.status === 'loading')
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.requestState.status === 'ready')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Grid, { size: "md" }, {
            default: _withCtx(() => [
              _createVNode(_component_PageTitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.page?.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.page?.body)
            ? (_openBlock(), _createBlock(_component_RichText, {
                key: 0,
                gridSize: "md",
                blocks: _ctx.page?.body
              }, null, 8, ["blocks"]))
            : _createCommentVNode("", true),
          _hoisted_1
        ], 64))
      : _createCommentVNode("", true)
  ]))
}